export default class ProposalFlags {
    public subProposalFlag!: boolean;
    public priceList!: boolean;
    public customerPartSent!: boolean;
    public referenceInsertSent!: boolean;
    public mathData!: boolean;
    public engApprovalNeeded!: boolean;
    public salesEngApproval!: boolean;
    public releaseToESTFromDW!: boolean;
    public voidFlag!: boolean;
    public checkDocComplete!: boolean;
    public designReleased!: boolean;
    public designKickback!: boolean;
    public estimationComplete!: boolean;
    public designWaitingForVendorQts!: boolean;
    public majorOpportunity!: boolean;
    public iprMajorOpComplete!: boolean;
    public designComplete!: boolean;
    public customerOrderRecd!: boolean;
    public releaseToProduction!: boolean;
    public outsideProcess!: boolean;
    public priceListCostUpdate!: boolean;
    public createSFQQuote!: boolean;
    public sampleRequired!: boolean;
    public salesMajorOpportunity!: boolean;

    public projectRequirementKickback!: boolean;
    public checkDocReq!: boolean;
    public checkDocChangesNeeded!: boolean;
    public checkDocChangesComplete!: boolean;
    public estimationKickback!: boolean;

    public useDefaultAddress!: boolean;

    public finishedGoods!: boolean;
    public precisionRack!: boolean;
    public designOnly!: boolean;
    public quickQuote!: boolean;

    constructor(init?: Partial<ProposalFlags>) {
        Object.assign(this, init);
    }
}